// DebugInstanceMenu.tsx
// Debug menu for managing instances, only included in build if REACT_APP_BUILD_ENV === 'true'.
import React, { useState } from "react";
import { useAppSelector } from "store/hooks";
import { default as API } from "utils/api";

const isDebug = process.env.REACT_APP_BUILD_ENV === "true";

let DebugInstanceMenu: React.FC = () => null;

if (isDebug) {
  DebugInstanceMenu = () => {
    const currentUser = useAppSelector((state) => state.auth.user_me);
    const [userId, setUserId] = useState(currentUser?.id || "");
    const [instances, setInstances] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [hasFetched, setHasFetched] = useState(false);

    const fetchInstances = async () => {
      setLoading(true);
      setError("");
      setHasFetched(false);
      try {
        const res = await API({ method: "get", url: `/instances?owner_id=${userId}` });
        setInstances(res.data);
        setHasFetched(true);
      } catch (err) {
        setError("Failed to fetch instances");
        setHasFetched(true);
      }
      setLoading(false);
    };

    const deleteInstance = async (id: string) => {
      setLoading(true);
      setError("");
      try {
        await API({ method: "delete", url: `/instance/${id}` });
        setInstances((prev) => prev.filter((i) => i.id !== id));
      } catch (err) {
        setError("Failed to delete instance");
      }
      setLoading(false);
    };

    return (
      <div className="w-full max-w-[500px] bg-white rounded-xl shadow-[0px_7px_29px_0px_rgba(100,100,111,0.20)] p-4 border border-blue max-h-[80vh] overflow-y-auto">
        <h2 className="custom-text-[poppins-600-18px] mb-2 text-blue">Debug Instances</h2>
        <div className="mb-2">
          <input
            className="w-full mb-1 px-2 py-1 border rounded custom-text-[poppins-400-14px]"
            placeholder="User ID"
            value={userId}
            onChange={e => setUserId(e.target.value)}
          />
          <button
            className="w-full bg-blue text-white rounded py-2 custom-text-[poppins-500-14px] hover:bg-blue-dark"
            onClick={fetchInstances}
            disabled={loading}
          >
            {loading ? "Loading..." : "Fetch Instances"}
          </button>
          {error && <div className="mt-1 text-red-500">{error}</div>}
        </div>
        <div className="max-h-[200px] overflow-y-auto">
          {instances.length > 0 ? (
            instances.map(i => (
              <div key={i.id} className="flex justify-between items-center py-1 border-b">
                <div>
                  <div className="custom-text-[poppins-500-14px]">{i.lab_id}</div>
                  <div className="custom-text-[poppins-400-12px] text-gray-500">{i.id}</div>
                </div>
                <button
                  className="ml-2 bg-red text-white rounded px-2 py-1 custom-text-[poppins-500-12px] hover:bg-red-700"
                  onClick={() => deleteInstance(i.id)}
                  disabled={loading}
                >
                  Delete
                </button>
              </div>
            ))
          ) : (
            hasFetched && !loading && <div className="text-gray-500 text-center py-2 custom-text-[poppins-400-14px]">No instances found.</div>
          )}
        </div>
      </div>
    );
  };
}

export default DebugInstanceMenu; 